import type { IHeatmapAnalytics } from '../types';

import { DEFAULT_VIEW_ID } from '@gem-sdk/heatmap-react';
import { create } from 'zustand';

interface IHeatmapAnalyticState {
  /** Analytics data per viewId */
  data: Map<string, IHeatmapAnalytics>;
}

interface IHeatmapAnalyticActions {
  setData: (data: IHeatmapAnalytics, viewId?: string) => void;
  copyView: (fromViewId: string, toViewId: string) => void;
  clearView: (viewId: string) => void;
  resetAll: () => void;
}

export interface IHeatmapAnalyticStore extends IHeatmapAnalyticState, IHeatmapAnalyticActions {}

const initialState: IHeatmapAnalyticState = {
  data: new Map(),
};

export const useHeatmapAnalyticStore = create<IHeatmapAnalyticStore>()((set, get) => ({
  ...initialState,

  setData: (data, viewId = DEFAULT_VIEW_ID) => {
    const newData = new Map(get().data);
    newData.set(viewId, data);
    set({ data: newData });
  },

  copyView: (fromViewId, toViewId) =>
    set((prev) => {
      const newData = new Map(prev.data);

      const fromData = prev.data.get(fromViewId);
      if (fromData) newData.set(toViewId, fromData);

      return { data: newData };
    }),

  clearView: (viewId) =>
    set((prev) => {
      const newData = new Map(prev.data);

      newData.delete(viewId);

      return { data: newData };
    }),

  resetAll: () => set({ data: new Map() }),
}));
